<template>
	<div class="email">
		<el-dialog :title="emailStatus ? '修改邮箱' : '添加邮箱'" :visible.sync="emailvisible" width="30%" :before-close="handleClose">
			<div class="email__content">Email： <el-input v-model="params.email" placeholder="多个邮箱用逗号隔开"></el-input></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="commit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'Email',
	props: {
		emailvisible: {
			type: Boolean,
			default: false,
		},
		emailStatus: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			params: {
				userId: '',
				userName: '',
				email: '',
			},
		};
	},
	methods: {
		handleClose() {
			this.$emit('closeEamil');
		},
		async commit() {
			if (!this.params.email) return this.$message.error('请输入邮箱');
			const { data } = await this.$API.updateUserEmail(this.params);
			if (data.code) return this.$message.error(data.msg);
			this.$message.success(data.msg);
			this.handleClose();
		},
		changeData(row) {
			this.params.userId = row.userId;
			this.params.userName = row.userName;
			this.params.email = row.email;
		},
	},
	// watch: {
	// 	emailvisible: (n) => {
	// 		console.log(n);
	// 	},
	// },
};
</script>

<style lang="scss" scoped>
.email__content {
	display: flex;
	word-break: keep-all;
	align-items: center;
}
</style>
